import { useEffect, useRef, useState } from 'react';
import { PROJECT_ARENAS } from '../../data/chapters';
import { chapterAtZ } from '../../data/chapters';
import { useGameStore } from '../../core/store';
import './arena-overlay.css';

/** Brief themed project-arena portals as the runner crosses Z thresholds. */
export function ArenaOverlay() {
  const runnerZ = useGameStore((s) => s.runnerZ);
  const activeArena = useGameStore((s) => s.activeArena);
  const setActiveArena = useGameStore((s) => s.setActiveArena);
  const seen = useRef(new Set<string>());
  const [visible, setVisible] = useState(false);
  const chapter = chapterAtZ(runnerZ);

  useEffect(() => {
    for (const a of PROJECT_ARENAS) {
      if (seen.current.has(a.id)) continue;
      if (runnerZ <= a.z + 1.5 && runnerZ > a.z - 4) {
        seen.current.add(a.id);
        setActiveArena(a.id);
        setVisible(true);
        const hide = window.setTimeout(() => {
          setVisible(false);
          setActiveArena(null);
        }, 3200);
        return () => window.clearTimeout(hide);
      }
    }
  }, [runnerZ, setActiveArena]);

  const arena = PROJECT_ARENAS.find((a) => a.id === activeArena);

  return (
    <>
      <div className="chapter-chip" aria-live="polite">
        <span>{chapter.title}</span>
        <small>{chapter.subtitle}</small>
      </div>

      {visible && arena && (
        <div
          className="arena-portal"
          style={{ ['--arena' as string]: arena.color }}
          role="status"
        >
          <p className="arena-portal__eyebrow">Project Arena Unlocked</p>
          <h2>{arena.label}</h2>
          <p>{arena.blurb}</p>
        </div>
      )}
    </>
  );
}
